var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "解决",
        visible: _vm.dialogVisibleSolve,
        width: "90%",
        "before-close": _vm.handleCloseSolve,
        "close-on-press-escape": false,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisibleSolve = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { ref: "solve", attrs: { model: _vm.solve, inline: true } },
        [
          _c(
            "el-form-item",
            {
              staticClass: "solve_summernote_item",
              staticStyle: { width: "100%" },
              attrs: { prop: "content" }
            },
            [
              _c("van-field", {
                staticStyle: {
                  border: "0 solid #F5F5F5",
                  "border-width": "3px 0 0 0",
                  "font-size": "115%"
                },
                attrs: {
                  type: "textarea",
                  maxlength: "999",
                  "show-word-limit": "",
                  rows: "2",
                  autosize: "",
                  placeholder: "添加回复"
                },
                model: {
                  value: _vm.solve.content,
                  callback: function($$v) {
                    _vm.$set(_vm.solve, "content", $$v)
                  },
                  expression: "solve.content"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "10px",
                    border: "0 solid #F5F5F5",
                    "border-width": "0 0 5px 0"
                  }
                },
                [_c("MobileTicketUpload", { ref: "up5" })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCloseSolve } }, [
            _vm._v("取消")
          ]),
          _vm._v(" "),
          _c("SubmitTicketButton", {
            ref: "solveBtn_1",
            attrs: { buttonText: "提交" },
            on: { click: _vm.solveOrder }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfebb17e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfebb17e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketSolveDialog.vue
// module id = 594
// module chunks = 75